import * as angular from 'angular';

import { ConfirmDialogService } from '@mode/shared/ui';

class IdentityScimToggleController {
  static $inject = ['ConfirmDialogService'];
  private checked = false;

  constructor(private confirmDialogService: ConfirmDialogService) {}

  private onToggle: ($args: { $checked: boolean }) => void;
  private handleToggle(): void {
    if (this.checked) {
      this.confirmDialogService.open({
        dialogTitle: 'Disable SCIM integration',
        dialogText: ` By disabling your SCIM integration, SCIM providers will no longer be able
        to sync with Mode. All users will need to be managed manually in Workspace settings..<br><br>
        To use a SCIM provider again, simply re-enable your integration.`,
        confirmText: 'Disable SCIM',
        confirmButtonColor: 'alert',
        cancelText: 'Cancel',
        confirmAction: () => {
          this.updateChecked();
        },
      });
    } else {
      this.updateChecked();
    }
  }
  private updateChecked() {
    this.checked = !this.checked;
    this.onToggle({ $checked: this.checked });
  }
}

export const IdentityScimToggleComponent: angular.IComponentOptions = {
  controller: IdentityScimToggleController,
  controllerAs: 'ctrl',
  bindings: {
    checked: '<',
    onToggle: '&',
  },
  template: `
    <div>
      <checkbox-toggle
        ng-click="ctrl.handleToggle()"
        checked="ctrl.checked"
      />
    </div>
  `,
};
